@if (form.controls.sendBy.value === SendOption.Email && checkSentNotification()) {
  <app-disclaimer
    color="green"
    icon="ic-checkmark-circle-20"
  >
    <span class="line-height-20 h-100 d-flex align-items-end gap-1" [innerHtml]="getSendEmailNotification()"></span>
  </app-disclaimer>
}

@if (documentSigning?.signingStatus === SigningStatus.Signed || documentSigning?.signingStatus === SigningStatus.MarkedAsSigned) {
  <div class="d-flex flex-column gap-24 mb-4">
    <app-lodge-documents
      [documentStatus]="documentStatus"
      [sendBy]="form.controls.sendBy.value"
      [documentId]="documentBase.documentId"
      [lodgement]="lodgement"
      [confirmAction$]="confirmAction$"
      (nextStep)="nextStep.emit(true)"
      (reloadDocument)="reloadDocument.emit(true)"
    />
  </div>
}

<div class="sign-documents-container" [formGroup]="form">
  @if (documentSigning?.signingStatus !== SigningStatus.Signed) {
    <div class="title-container">
      <h3>Sign Documents</h3>
    </div>
  }

  <div class="sent-container">
    <app-send-by-radio
      formControlName="sendBy"
      [options]="sendByOptions"
      [isLoading]="isProviderConnectionStatusLoading"
      [eSignSource]="selectedESignConnection"
    />

    <div class="buttons-container">
      @if ((form.controls.sendBy.value === SendOption.Sign) && asicStatus == AsicStatus.NotLodged) {
        @if (isEnvelopeSent) {
          <app-button
            text="Void Envelope"
            [loading]="envelopeLoading"
            [isDisabled]="envelopeLoading || disabledVoidEnvelopeBtn"
            (click)="voidEnvelope()"
          />
        } @else {
          <app-button
            text="Carbon Copy"
            iconClass="icon ic-add-20"
            btnColor="white"
            [isDisabled]="carbonCopy.length === maxCarbonCopyNumber"
            (click)="(carbonCopy.length <= maxCarbonCopyNumber) && addCarbonCopy()"
          />
          <app-button
            text="Approver"
            iconClass="icon ic-add-20"
            btnColor="white"
            [isDisabled]="!!approver"
            (click)="!approver && addApprover()"
          />
        }
      }

      @if (documentSigning?.signedByPaper && form.controls.sendBy.value === SendOption.Paper) {
        <app-button
          text="Void Paper Signing"
          [loading]="envelopeLoading"
          [isDisabled]="envelopeLoading || disabledVoidEnvelopeBtn"
          (click)="voidPaperSign()"
        />
      }
    </div>
  </div>

  <div class="form-body-container">
    @if (form.controls.sendBy.value === SendOption.Sign) {
      @if (documentSigning?.signingStatus !== SigningStatus.Signed && !isEnvelopeSent && asicStatus == AsicStatus.NotLodged) {
        <app-notification
          iconClass="icon ic-info-circle-20"
          color="orange"
          [text]="eSignMsg"
        />
      }

      @if (signErrorMessage) {
        <app-notification
          iconClass="icon ic-cancel-circle-20"
          color="red"
          [text]="signErrorMessage"
        />
      }

      <div class="subject">
        <app-list-grid-client-side
          class="sign-list signing-grid"
          [rowData]="rows"
          [colDefs]="$any(colDefs)"
          [rowSelection]="signListRowSelection"
          [headerHeight]="0"
          [gridOptions]="gridOptions"
          [pagination]="false"
          [paginationPageSizeSelector]="false"
          (gridReady)="onGridReady($event)"
        />
      </div>
      @if (documentSigning?.signingStatus !== SigningStatus.Signed && !isEnvelopeSent && asicStatus == AsicStatus.NotLodged) {
        <app-checkbox
          label="I want to attach the uploaded documents to the envelope"
          [value]="includeAttachedFiles"
          (change)="includeAttachedFiles = $event"/>
      }
    } @else if (form.controls.sendBy.value === SendOption.Email) {
      <app-multiple-input-email
        label="To"
        placeholder="Enter email"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onChangeEmailList($event)"
        [(ngModel)]="emailList"
      />
      <div>
        <app-checkbox
          label="I want to attach the uploaded documents to the email"
          [value]="includeAttachedFiles"
          (change)="includeAttachedFiles = $event"/>
      </div>
    } @else if (form.controls.sendBy.value === SendOption.Paper) {
      @if (documentSigning?.signingStatus !== SigningStatus.Signed) {
        <app-notification
          iconClass="icon ic-info-circle-20"
          color="orange"
          [text]="paperSignMsg"
        />

        <div class="signing-contact">
          <app-date-picker
            label="Signing Date"
            [minDate]="signingMinDate"
            [maxDate]="signingMaxDate"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onSigningDateChange($event)"
            [(ngModel)]="signingDate"
          />
        </div>

        @if (errorMessage) {
          <app-notification
            iconClass="icon ic-cancel-circle-20"
            color="red"
            [text]="errorMessage"
          />
        }

        @if (uploadedFiles.length) {
          <div class="files-container">
            @for (file of uploadedFiles; track $index) {
              <app-file-label
                [hideDownloadBtn]="true"
                (deleteFile)="deleteFile($index)"
              >
                {{ file.name }}
              </app-file-label>
            }
          </div>
        } @else {
          <div>
            <app-file-upload
              [multiple]="true"
              [acceptedFormatsList]="[acceptedFormat]"
              [lodgeView]="true"
              (change)="onFilesLoaded($event)"
            >
              <div class="note">{{ uploadNotification }}</div>
            </app-file-upload>
          </div>
        }
      } @else {
        <app-notification
          iconClass="icon ic-checkmark-circle-20"
          color="green"
          [text]="'Documentation was signed by Paper on ' + (signingDate | date: 'dd MMM yyyy' : '+1000')"
        />
      }
    }

    @if (form.controls.sendBy.value === SendOption.Sign && !isEnvelopeSent || form.controls.sendBy.value === SendOption.Email) {
      <div class="mw-100 overflow-auto">
        <div class="email-preview-wrapper">
          <app-email-preview
            [documentBase]="documentBase"
            [sendByMethod]="form.controls.sendBy.value"
            [lodgement]="lodgement"
            [isDocument]="true"
            (changeEmail)="onChangeEmail($event)"
          />
        </div>
      </div>
    }
  </div>
</div>
